
import React from 'react';

import * as utils from "../../utils";

import SimpleModal from "./simple-modal";

/* This component can do a few things:
  - render jifiti gifts in a modal on desktop
  - open jifiti gifts in a new tab on mobile
  - open an appstore url in a new tab (if bucketed by an optimizely test)
  - make a call to render a marketing interstitial (if bucketed by an optimizely test)

  It's pretty cufty and, with any luck, this whole thing will go away when we move Jifiti gift to its own tab.
*/

const JifitiGiftLink = React.createClass({
  getInitialState: function() {
    return {
      isModalOpen: false
    };
  },
  componentDidMount: function() {
    window.onmessage = (e) => {
      if (e.data === "close-modal") {
        this.closeModal();
      }
    };
  },
  render: function() {
    if (shouldNotShowInstantGifting()) {
      return null;
    }

    const style = getSimpleModalStyle();
    const isMobile = utils.isMobile();
    const isIpad = utils.isIpad();
    const imgPath = `/assets/images/v2/web/instant_gifts_banner${ isMobile ? "_mobile.png" : "_nolearnmore.jpg"}`;
    const topText = Boolean(window.gift_registry_provider) ? "More gift ideas..." : "Send a Gift";
    const infoText = isMobile ? "Send a gift instantly via text or email." :
      "Evite Instant Gifts allows you to send gifts instantly via text or email.";
    const topClassNames = `jifiti-gift ${this.props.compactVersion ? "compact-version" : "simple-shadowbox"}${isMobile ? " mobile" : ""}`;

    if (this.props.compactVersion) {
      // this is the compact version - currently used on the RSVP tab
      return (
        <div className={topClassNames} id="instant-gifting">
          <div className="gift-icon">
            <div className="icon-holder icon-gifts"></div>
          </div>
          <div className="gifts-text">
            <p id="send-gift-message"><strong>Send your gift now:</strong> It's super simple!</p>
            <p id="send-gift-link">
            { isMobile || isIpad ?
              <a
                href={window.jifiti_gift_url}
                target="_blank" id="from-host-jifiti-button"
                onClick={this.handleMobileClick}
                className="start-gifting"
              >Send a Gift Now</a>
            :
              <a
                href="#"
                onClick={this.handleDesktopClick}
                className="start-gifting"
              >Send a Gift Now</a>
            }
            </p>
          </div>
          { (!isMobile || isIpad) &&
            <SimpleModal
              isOpen={this.state.isModalOpen}
              onCloseClick={this.closeModal}
              modalId="jifiti-frame"
              modalClassName="jifiti-frame"
              hideCloseButton={true}
              inlineInnerStyle={style}
            >
              <iframe src={window.jifiti_gift_url}></iframe>
            </SimpleModal>
          }
        </div>
      );
    }

    // not the compact version - banner image, etc.
    return (
      <div className={topClassNames} id="instant-gifting">
        <div className="gift-icon">
          <div className="icon-holder icon-gifts"></div>
        </div>
        <div className="gifts-text">
          <h3>{topText}</h3>
          <p>{infoText}</p>
        </div>

        <img src={imgPath} className="instant-gifting-banner" />

        <p className="instant-gifts-footer">
          { isMobile || isIpad ?
            <a
              href={window.jifiti_gift_url}
              target="_blank"
              id="from-host-jifiti-button"
              onClick={this.handleMobileClick}
              className="start-gifting"
            >Start Gifting</a>
          :
            <a
              href="#"
              onClick={this.handleDesktopClick}
              className="start-gifting"
            >Start Gifting</a>
          }
        </p>
        { (!isMobile || isIpad) &&
          <SimpleModal
            isOpen={this.state.isModalOpen}
            onCloseClick={this.closeModal}
            modalId="jifiti-frame"
            modalClassName="jifiti-frame"
            hideCloseButton={true}
            inlineInnerStyle={style}
          >
            <iframe src={window.jifiti_gift_url}></iframe>
          </SimpleModal>
        }
      </div>
    );
  },
  handleMobileClick: function(e) {
    if (window.jifiti_marketing_overlay && !utils.isIpad()) {
      return window.marketing_overlay.launch_click(e);
    }
  },
  handleDesktopClick: function(e) {
    e.preventDefault();
    this.setState({ isModalOpen: true });
  },
  closeModal: function() {
    this.setState({ isModalOpen: false });
  }
});

function shouldNotShowInstantGifting() {
  return !window.jifiti_gift_url || window.donations_enabled || window.wishlist_enabled || !window.evite_event.options.event_option_show_gifting;
}

function getSimpleModalStyle() {
  let docHeight = $(window).height();
  let docWidth = $(window).width();
  let ratio = 1.382113821138211;   // width(850) divided by height(615);
  let winHeight, winWidth;

  if (docHeight > 768) {
    winHeight = docHeight * 0.905;
    winWidth = ratio * winHeight;
  } else {
    winWidth = 850;
    winHeight = 615;
  }

  if (winWidth > docWidth) {
    winWidth = docWidth * 0.905;
    winHeight = winWidth / ratio;
  }

  let top = (docHeight - winHeight) / 2;
  let style = {
    width: winWidth + "px",
    height: winHeight + "px",
    top: top + "px"
  }
  return style;
}

export default JifitiGiftLink;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/jifiti-gift-link.es6